import React from 'react';
import PropTypes from "prop-types";
import clsx from "clsx";

const defaultStyles = {
    width: '1em',
    height: '1em',
    overflow: 'hidden',
    fontSize: '1.5rem',
    flexShrink: 0,
    userSelect: 'none'
};
const classTypes = {
    'outlined': 'material-icons-outlined',
    'symbols-outlined': 'material-symbols-outlined',
    'symbols-rounded': 'material-symbols-rounded',
    'regular': 'material-icons'
}
const IconCustom = React.forwardRef(function IconCustom(props, ref) {
    const iconClassnames = clsx(props.className, classTypes[props.iconType]);
    let childIcon = typeof props.children === "string" ? props.children : "";
    return (
        <span
            {...props}
            ref={ref}
            className={iconClassnames}
            style={{...defaultStyles, ...props.style}}>
            {childIcon}
        </span>
    )
});

export default IconCustom
IconCustom.propTypes = {
    iconType: PropTypes.oneOf(['outlined', 'regular', 'symbols-outlined', 'symbols-rounded']),
    styles: PropTypes.object,
    className: PropTypes.any
}
IconCustom.defaultProps = {
    style: {},
    iconType: 'regular',
}